import { API_BASE } from 'shared/constants/Api'

export const REGISTER = `${API_BASE}/api/v2/ident-service/auth/`
